import { getRequest } from '../../services/base'
import { notifyError, notifySuccess } from '../../utils/notifications'

export const SELECT_ALL = 'SELECT_ALL'
export const DESELECT_ALL = 'DESELECT_ALL'

export const handleEnterKey = (evt, callback) => {
  if (evt.key === 'Enter') {
    evt.preventDefault()
    if (callback) {
      callback(evt)
    }
  }
}

// `dispatch` and `intl` are required - both call sites (connector_views/index.js
// and ConnectorViewForm.js) always pass them. They used to be optional, with a
// window.confirm() fallback that was therefore unreachable.
export const downloadAsZip = async (id, file_name, dispatch, intl) => {
  dispatch({
    type: 'loader',
    data: {
      caption: intl.formatMessage(
        { id: 'connectorViews.list.downloading' },
        { file_name }
      ),
      showLoader: true,
    },
    notification: {},
  })

  const res = await getRequest(`/api/connector_views/zip/${id}/`, true, true)

  // Test `status`, not `msg`: on success this response is the raw blob, and on
  // failure base.js returns the error shape. Keying on `msg` meant a failure
  // whose body carried no message fell through to the success branch below and
  // downloaded the error object as a .zip.
  if (res?.status === false) {
    notifyError(
      dispatch,
      intl.formatMessage({ id: 'connectorViews.list.downloadError' })
    )
    return
  }

  /* Start Download Zip file  */
  const downloadZipUrl = window.URL.createObjectURL(new Blob([res]))
  const zipFileLink = document.createElement('a')
  zipFileLink.href = downloadZipUrl
  zipFileLink.setAttribute('download', `${file_name}.zip`)
  document.body.appendChild(zipFileLink)
  zipFileLink.click()
  zipFileLink.remove()
  /* End Download Zip file  */

  notifySuccess(
    dispatch,
    intl.formatMessage({ id: 'connectorViews.list.downloadSuccess' })
  )
}
